var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.43847H9.42346V2.88446H0V4.43847ZM11.1368 0.326416C10.8774 0.364538 10.643 0.502053 10.4831 0.709885C10.3232 0.917718 10.2504 1.17958 10.2801 1.4401V5.88712C10.2504 6.14764 10.3232 6.4095 10.4831 6.61733C10.643 6.82516 10.8774 6.96268 11.1368 7.0008C11.3962 6.96268 11.6307 6.82516 11.7905 6.61733C11.9504 6.4095 12.0232 6.14764 11.9935 5.88712V1.4401C12.0232 1.17958 11.9504 0.917718 11.7905 0.709885C11.6307 0.502053 11.3962 0.364538 11.1368 0.326416ZM5.99675 9.55713V8.11105C6.02645 7.85053 5.95366 7.58867 5.79379 7.38084C5.63392 7.17301 5.39949 7.03549 5.14007 6.99737C4.88065 7.03549 4.64622 7.17301 4.48635 7.38084C4.32648 7.58867 4.2537 7.85053 4.28339 8.11105V12.5598C4.2537 12.8203 4.32648 13.0822 4.48635 13.29C4.64622 13.4978 4.88065 13.6353 5.14007 13.6735C5.39949 13.6353 5.63392 13.4978 5.79379 13.29C5.95366 13.0822 6.02645 12.8203 5.99675 12.5598V11.1137H11.9935V9.55713H5.99675ZM0 11.1137H3.42671V9.55713H0V11.1137Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.9406c5033bfb0d916e0265dcbeb2920e.svg";
export { ForwardRef as ReactComponent };